import constate from 'constate';
import { useCallback, useState } from 'react';
import { HeaderState } from './header-state';

function useHeaderValues() {
  const [headerState, setHeaderState] = useState<HeaderState>({ title: '' });

  const updateHeaderState = useCallback((updatedHeaderState: Partial<HeaderState>) => {
    setHeaderState((headerState) => ({ ...headerState, ...updatedHeaderState }));
  }, []);

  return { headerState, updateHeaderState, replaceHeaderState: setHeaderState };
}

export const [AppHeaderProvider, useAppHeader] = constate(useHeaderValues);
